// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"af2fa4f1","555":"5e2350b7","599":"d03e85df","644":"9777bd42","767":"4b70eddb","908":"f045bd1e"}[chunkId] + ".chunk.js";
};